import React, { ClipboardEventHandler, ReactElement } from "react";
import "./PreviewPane.scss";
import { IEditableModuleStates, IModuleList, TModuleCallback } from "@src/types";

interface IDynamicDivProps {
    id: string,
    html: string,
    onInput: (divId: string, moduleId: string) => void,
    module: string,
    editable: boolean,
    editModule: TModuleCallback
}

/**
 * The div used to render a module
 */
const DynamicDiv: React.FC<IDynamicDivProps> = ({id, html, onInput, module, editable, editModule}) => {
    return (
        // using blur because onChange or onInput would not fire correctly
        <div
            id={id}
            contentEditable={editable}
            onBlur={() => onInput(id, module)}
            dangerouslySetInnerHTML={{ __html: html }}
            onClick={() => editModule(module)}
        />
    );
}

/**
 * Override the default paste behavior to make pasting from outside sources smoother
 * If rich-paste text is found, then clear newlines and paste as raw text
 */
function customPaste(e: React.ClipboardEvent<HTMLDivElement>) {
    let pasteHTML = e.clipboardData.getData("text/html");
    let pasteText = e.clipboardData.getData("text");

    //check to see if it is a panel
    if (pasteHTML.includes("rich-paste")) {
        return;
    }

    e.preventDefault();

    pasteText = pasteText.replace(/(\r\n|\n|\r)/gm, " ");

    let selection = document.getSelection();
    let txt = document.createTextNode(pasteText);
    if (!selection?.rangeCount) return false;
    selection?.deleteFromDocument();
    selection?.getRangeAt(0).insertNode(txt);
}

interface IPreviewPaneProps {
    modules: IModuleList;
    editStates: IEditableModuleStates;
    updateCurrentModuleStates: (divId: string, moduleId: string) => void;
    editModule: TModuleCallback;
}

/**
 * The collection of module divs
 */
export const PreviewPane: React.FC<IPreviewPaneProps> = ({modules, editStates, updateCurrentModuleStates, editModule}) => {
    const moduleViewArr = new Array<ReactElement>();

    for (let current_module in modules) {
        if (!modules[current_module].default) {
            continue;
        }

        let content = (
            <DynamicDiv
                id={current_module + "DIV"}
                key={current_module + "DIV"}
                html={modules[current_module].currentHtml}
                onInput={updateCurrentModuleStates}
                module={current_module}
                editable={editStates[current_module].editable}
                editModule={editModule}
            />
        );
        moduleViewArr.push(content);
    }

    return (
        <div className="preview">
            <div id="preview_wrapper" onPaste={customPaste}>
                {moduleViewArr}
                <br />
            </div>
        </div>
    );
}
